

(function () {
  'use strict';

  function mount(el) {
    if (el.__cerusSplide || !window.Splide) return;

    var perDesktop = parseFloat(el.dataset.perViewDesktop) || 4;
    var perTablet  = parseFloat(el.dataset.perViewTablet)  || 2.2;
    var perMobile  = parseFloat(el.dataset.perViewMobile)  || 1.2;
    var autoplay   = el.dataset.autoplay === 'true';
    var interval   = parseInt(el.dataset.interval, 10) || 5;


    var slideCount = el.querySelectorAll('.splide__slide').length;
    var useLoop = slideCount > perDesktop;

    var splide = new window.Splide(el, {
      type: useLoop ? 'loop' : 'slide',
      perPage: perDesktop,
      perMove: 1,
      gap: '20px',
      arrows: el.querySelector('.cerus-pcarousel__arrows') !== null,
      pagination: el.querySelector('.cerus-pcarousel__pagination') !== null,
      autoplay: autoplay,
      interval: interval * 1000,
      speed: 600,
      easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)',
      rewind: !useLoop,
      drag: true,
      pauseOnHover: true,
      pauseOnFocus: true,
      snap: true,
      flickPower: 360,
      breakpoints: {
        1200: { perPage: Math.max(3, perDesktop - 1), gap: '18px' },
        1024: { perPage: perTablet,                   gap: '16px' },
        900:  { perPage: Math.max(2, perTablet - 0.4),gap: '14px' },
        749:  { perPage: perMobile,                   gap: '12px', arrows: false },
        540:  { perPage: 1.1,                         gap: '10px' }
      }
    });

    splide.mount();
    el.__cerusSplide = splide;
    setTimeout(function () { try { splide.refresh(); } catch (e) {} }, 80);



    var section = el.closest('.cerus-section') || el.parentNode;
    if (section) {
      var prevBtn = section.querySelector('[data-cerus-pcarousel-prev]');
      var nextBtn = section.querySelector('[data-cerus-pcarousel-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { splide.go('<'); });
      if (nextBtn) nextBtn.addEventListener('click', function () { splide.go('>'); });
    }

    if (autoplay && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) splide.Components.Autoplay.play();
          else                       splide.Components.Autoplay.pause();
        });
      }, { threshold: 0.2 });
      io.observe(el);
      el.__cerusIO = io;
    }
  }

  function unmount(el) {
    if (!el) return;
    if (el.__cerusSplide) {
      try { el.__cerusSplide.destroy(); } catch (err) {  }
      el.__cerusSplide = null;
    }
    if (el.__cerusIO) {
      try { el.__cerusIO.disconnect(); } catch (err) {  }
      el.__cerusIO = null;
    }
  }

  var initPolls = 0;
  function init(scope) {
    var root = (scope && scope.querySelectorAll) ? scope : document;
    var els = root.querySelectorAll('[data-cerus-pcarousel]');
    if (!els.length) return;
    if (!window.Splide) {
      initPolls++;
      if (initPolls < 50) setTimeout(function () { init(scope); }, 100);
      return;
    }
    els.forEach(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });

    document.addEventListener('shopify:section:unload', function (e) {
      e.target.querySelectorAll('[data-cerus-pcarousel]').forEach(unmount);
    });

    document.addEventListener('shopify:section:select', function (e) {
      var el = e.target.querySelector('[data-cerus-pcarousel]');
      if (el && el.__cerusSplide && el.__cerusSplide.Components.Autoplay) {
        el.__cerusSplide.Components.Autoplay.pause();
      }
    });

    document.addEventListener('shopify:section:deselect', function (e) {
      var el = e.target.querySelector('[data-cerus-pcarousel]');
      if (el && el.__cerusSplide && el.dataset.autoplay === 'true' && el.__cerusSplide.Components.Autoplay) {
        el.__cerusSplide.Components.Autoplay.play();
      }
    });

    document.addEventListener('shopify:block:select', function (e) {
      var section = document.getElementById('shopify-section-' + e.detail.sectionId);
      if (!section) return;
      var el = section.querySelector('[data-cerus-pcarousel]');
      if (!el || !el.__cerusSplide) return;
      el.__cerusSplide.Components.Autoplay && el.__cerusSplide.Components.Autoplay.pause();
      var slides = el.querySelectorAll('.splide__slide');
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].dataset.shopifyEditorBlock && slides[i].dataset.shopifyEditorBlock.indexOf(e.detail.blockId) !== -1) {
          el.__cerusSplide.go(i);
          break;
        }
      }
    });

    document.addEventListener('shopify:block:deselect', function (e) {
      var section = document.getElementById('shopify-section-' + e.detail.sectionId);
      if (!section) return;
      var el = section.querySelector('[data-cerus-pcarousel]');
      if (el && el.__cerusSplide && el.dataset.autoplay === 'true' && el.__cerusSplide.Components.Autoplay) {
        el.__cerusSplide.Components.Autoplay.play();
      }
    });
  } else {

    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  }
})();
